__turbopack_context__.v({
  "actions": "Conclusion-module__SCuWxq__actions",
  "birdAside": "Conclusion-module__SCuWxq__birdAside",
  "birdCaption": "Conclusion-module__SCuWxq__birdCaption",
  "birdImage": "Conclusion-module__SCuWxq__birdImage",
  "birdMedia": "Conclusion-module__SCuWxq__birdMedia",
  "birdMeta": "Conclusion-module__SCuWxq__birdMeta",
  "blockCentered": "Conclusion-module__SCuWxq__blockCentered",
  "blockReach": "Conclusion-module__SCuWxq__blockReach",
  "blockRow": "Conclusion-module__SCuWxq__blockRow",
  "blockRowReverse": "Conclusion-module__SCuWxq__blockRowReverse",
  "blockRowReverseText": "Conclusion-module__SCuWxq__blockRowReverseText",
  "blockRowText": "Conclusion-module__SCuWxq__blockRowText",
  "content": "Conclusion-module__SCuWxq__content",
  "datazoneLink": "Conclusion-module__SCuWxq__datazoneLink",
  "headingLarge": "Conclusion-module__SCuWxq__headingLarge",
  "proseBlock": "Conclusion-module__SCuWxq__proseBlock",
  "reachFootprints": "Conclusion-module__SCuWxq__reachFootprints",
  "reachWrap": "Conclusion-module__SCuWxq__reachWrap",
  "section": "Conclusion-module__SCuWxq__section",
  "stat": "Conclusion-module__SCuWxq__stat",
  "statAside": "Conclusion-module__SCuWxq__statAside",
  "subheading": "Conclusion-module__SCuWxq__subheading",
});
